<div class="card box-shadow box-border-bg">
    <loader size="medium" *ngIf="firstCount == undefined && secondCount == undefined"></loader>
    <ng-container *ngIf="firstCount != undefined && secondCount != undefined">
        <p class="midbold">{{ title }}</p>
        <div class="count-section">
            <p class="count">{{ firstCount }}</p>
            <p class="count-description">{{ firstCountDescription }}</p>
        </div>
        <div class="count-section">
            <p class="count">{{ secondCount }}</p>
            <p class="count-description">{{ secondCountDescription }}</p>
        </div>
    </ng-container>
</div>
